import { Input } from '@platform/design-system';
import { useFormContext } from 'react-hook-form';
import type { ProductFormValues } from '../product-form.ts';
import { useFieldError, type EditorSection } from './sections.ts';
import { EditorSectionCard } from './EditorSectionCard.tsx';
import styles from './ProductEditor.module.css';

export type SingleFieldSectionProps = {
  section: EditorSection;
  field: 'warrantyMonths';
  label: string;
  helperText?: string;
  inputMode: 'decimal' | 'numeric';
};

export const SingleFieldSection = ({
  section,
  field,
  label,
  helperText,
  inputMode,
}: SingleFieldSectionProps) => {
  const { register, formState } = useFormContext<ProductFormValues>();
  const errorText = useFieldError();
  return (
    <EditorSectionCard section={section}>
      <div className={styles['compactField']}>
        <Input
          label={label}
          helperText={helperText}
          inputMode={inputMode}
          dir="ltr"
          errorText={errorText(formState.errors[field])}
          {...register(field)}
        />
      </div>
    </EditorSectionCard>
  );
};
